import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import analysts_Architect_INTJ_personality_header from '../../images/personality_types_details/analysts_Architect_INTJ_personality_header.svg'
import analysts_Architect_INTJ_workplace_habits from '../../images/personality_types_details/analysts_Architect_INTJ_workplace_habits.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const intjs_at_work = () => {
    return (
        <Layout>
            <main className="q-td analyst architect">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/architect-intj-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-careers" className="tab with-progress">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intjs-at-work" className="tab with-progress active">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header className="type-header analyst architect">
                    <svg className="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path className="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path className="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>
                    <img src={analysts_Architect_INTJ_personality_header} className="scene" alt='loading...' />
                    <div className="type-info">
                        <h1><span>Architect</span> Personality</h1>
                        <div className="code">INTJ-A / INTJ-T</div>
                        <a href="#" className="difference">(What’s the difference?)</a>
                    </div>
                </header>


                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/architect-intj-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-careers">Career Paths</Link></li>
                                <li className="active"><Link to="/personality-types/architect-intjs-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>    Workplace Habits
</h1>


                        <p>What Architects (INTJs) want – wherever they may be in their careers – is to pursue their professional goals according to their own standards. And if any personality type has high standards for themselves, it’s almost certainly Architects.</p>

                        <p>In theory, this attitude makes for a model employee and coworker. And in many ways, Architects are exactly that. But some personality types may find it a challenge to work with Architects. Architects may be harsh or dismissive toward people they don’t respect – and unfortunately, losing their respect can be all too easy. In particular, they have little time for coworkers who prioritize convenience over innovation or socializing over success.</p>

                        <h2>Architect Subordinates</h2>

                        <p>Architects are known for their independence. Even in entry-level jobs, they may chafe at anyone who tries to limit their freedom. Their worst nightmare would be a micromanaging boss who monopolizes their time with pointless meetings, insists on useless rules, and appraises employees’ performance based on how likable they seem rather than their actual merits.</p>

                        <div class="scene"><img alt="Architect (INTJ) workplace habits" src={analysts_Architect_INTJ_workplace_habits} /></div>

                        <p>Titles mean little to Architects, and they often struggle to defer to a manager they don’t respect. They might also find it difficult to restrain themselves from offering their bosses feedback and criticism – an approach that, depending on the boss, can backfire.</p>

                        <p>In the real world, not all bosses will be as logical or open-minded as Architects might prefer. But that doesn’t mean that people with this personality type should allow a less-than-ideal manager to hold them back.</p>

                        <p>Architects may need to use all of their creativity and ingenuity to expand their responsibilities and develop their expertise – even if they don’t have the independence they crave. To do this, they may need to prioritize building a productive and respectful relationship with their manager, no matter how far from perfect that person may be.</p>

                        <h2>Architect Colleagues</h2>

                        <p>Few Architects choose jobs that require constant teamwork or social interaction. To these personalities, most team-building techniques and group meetings are a waste of time. And chitchat, gossip, and office politics – well, those can be nothing short of workplace plagues.</p>

                        <p>Many Architects would rather work alone than be slowed down by anyone who isn’t as focused as they are. Fortunately, their perfectionism and resolve often enable them to produce effective results even without the help of others.</p>

                        <p>That’s not to say that Architects can’t work with others – in fact, they may achieve some of their greatest successes this way. Their capability and reliability can make them excellent collaborators. People with this personality type may never enjoy pairing up with coworkers who get hung up on the wrong details or can’t otherwise earn their respect. But in the company of a small group of trusted colleagues, Architects’ brainstorming sessions may become even more electric.</p>

                        <h2>Architect Managers</h2>

                        <p>Though they may be surprised to hear it, Architects can make great leaders. In the workplace, they rarely throw around their authority just to prove that they’re in charge. Instead, they look for ways to promote innovation and effectiveness – even if that means breaking with established hierarchies. Some managers might enjoy being pandered to, but Architect personalities would rather be successful than constantly validated.</p>

                        <p>Generally speaking, Architects prefer to treat those who work for them as equals. Rather than micromanaging, they aim to direct broader strategies while letting other people handle day-to-day activities. That’s not to say that they’re completely hands-off, however. Architect bosses want to know exactly what’s going on and when, and they're always ready to drill into any level of detail necessary.</p>

                        <p>These managers respect and reward proactive behavior, delegating responsibilities to employees with the strongest critical-thinking skills. But this freedom isn’t just granted – it’s required. Employees who struggle to direct themselves – who just want to be told what to do – may have a hard time meeting Architects’ standards. And anyone who tries to cover up bad results with flattery or excuses is likely to be disappointed. Those strategies rarely work with Architect personalities.</p>

                        <div class="number">07</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/architect-intj-careers' className='next-feature'>
                            Career Paths
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/architect-intj-conclusion' className='next-feature'>
                            Conclusion
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default intjs_at_work
